<template>
  <div id="app" class="wrapper">
    <header-bar :route="route" :locale="locale"/>
      <transition mode="out-in">
        <router-view></router-view>
      </transition>
    <footer-bar />      
  </div>
</template>
<script>
import HeaderVue from "../components/common/Header.vue";
import FooterVue from "../components/common/Footer.vue";
import { mapState } from "vuex";

export default {
  components: {
    "header-bar": HeaderVue,
    "footer-bar": FooterVue
  },
  computed: mapState(["locale", "route"]),
  data() {
    return {
      locales: [{ lang: "en", txt: "English" }, { lang: "ar", txt: "Arabic" }],
      isMoreVisible: false
    };
  },
  methods: {}
};
</script>


// WEBPACK FOOTER //
// DesktopLayout.vue